<template>
  <q-card v-if="field" class="q-mb-md">
    <q-card-section class="bg-tertiary text-white drag-handle">
      <template class="justify-start content-start items-center">
        <q-item-section>
          <q-item-label lines="1" class="text-weight-medium">
            {{ field.title }}
          </q-item-label>
          <q-item-label>{{ field.description }}</q-item-label>
        </q-item-section>
      </template>

      <template class="justify-end content-end">
        <q-btn-group class="justify-end content-end float-right">
          <q-btn round size="xs" color="primary" @click="openSettings = !openSettings"
            ><i class="fas fa-pencil-alt" />
            <LmTooltip> Edit field settings </LmTooltip>
          </q-btn>

          <q-btn round size="xs" color="dark" @click="$emit('duplicate', index)"
            ><i class="fas fa-clone" />
            <LmTooltip> Clone field </LmTooltip>
          </q-btn>

          <q-btn round size="xs" color="negative" @click="$emit('remove', index)"
            ><i class="fas fa-trash-alt" />
            <LmTooltip> Delete field </LmTooltip>
          </q-btn>
        </q-btn-group>
      </template>
    </q-card-section>

    <q-separator />

    <q-card-section>
      <div v-if="field.type !== 'html'" class="row q-col-gutter-md">
        <div class="col">
          <q-field
            v-if="field.tag === 'q-option-group'"
            class="option-group"
            :label="field.settings.label"
            stack-label
            :hint="field.settings.helper || field.settings.settingPlaceholders.helper"
          >
            <component
              :is="field.tag"
              :id="`field_${field.index}`"
              v-model="fieldValue"
              :class="{
                'lm-textarea': field.tag === 'q-input' && field.type === 'textarea',
                'lm-radio-group': field.tag === 'q-option-group' && field.type === 'radio',
                'lm-checkbox-group': field.tag === 'q-option-group' && field.type === 'checkbox'
              }"
              :type="field.type"
              :label="field.settings.label || field.settings.settingPlaceholders.label"
              :rows="field.settings.rows"
              :options="field.settings.options"
              outlined
              color="tertiary"
            />
          </q-field>

          <component
            :is="field.tag"
            v-else
            :id="`field_${field.index}`"
            v-model="fieldValue"
            :class="{
              'lm-radio-group': field.tag === 'q-option-group' && field.type === 'radio',
              'lm-checkbox-group': field.tag === 'q-option-group' && field.type === 'checkbox'
            }"
            :type="field.type"
            :label="field.settings.label || field.settings.settingPlaceholders.label"
            :placeholder="field.settings.placeholder"
            :rows="field.settings.rows"
            :options="field.settings.options"
            :hint="field.settings.helper || field.settings.settingPlaceholders.helper"
            hide-bottom-space
            outlined
            color="tertiary"
          />
        </div>

        <div v-if="showClearValueButton" class="col-xs-2 self-center text-right">
          <q-btn color="faded" @click="fieldValue = field.type === 'checkbox' ? [] : null">Clear value</q-btn>
        </div>
      </div>

      <div v-else class="row">
        <div class="col-xs-12">
          <component :is="field.tag" :id="`field_${field.index}`" :style="field.settings.style" class="no-margin">{{
            fieldValue
          }}</component>
        </div>
      </div>

      <lm-draggable-form-component-settings
        :open="openSettings"
        :field="field"
        @update-field-settings="updateFieldSettings"
      />
    </q-card-section>
  </q-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import LmDraggableFormComponentSettings from './LmDraggableFormComponentSettings'

export default {
  name: 'LmDraggableFormComponent',
  components: {
    LmDraggableFormComponentSettings
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    field: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    openSettings: false
  }),

  computed: {
    showClearValueButton() {
      return this.field.type === 'checkbox' ? this.fieldValue.length > 0 : this.fieldValue
    },

    fieldValue: {
      get() {
        return this.field.settings.value
      },
      set(value) {
        this.$emit('update:field', { ...this.field, settings: { ...this.field.settings, value } })
      }
    }
  },

  methods: {
    updateFieldSettings({ prop, value }) {
      this.$emit('update:field', { ...this.field, settings: { ...this.field.settings, ...{ [prop]: value } } })
    }
  }
}
</script>

<style lang="stylus" scoped>
.option-group >>> .q-field__label {
  font-size 1.2rem !important
}
.q-item__section > .text-caption {
  color rgba(0, 0, 0, 0.74)
}
</style>
